import axios from "axios";
const CONTROLLER_PATH = "Provider";
class ProviderService {
    //CREATE
    create(formData) {
        return axios
            .post(CONTROLLER_PATH, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => response.data);
    }

    //READ
    get(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + (id ? "/" + id : ""), { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    getlist() {
        return axios.get(CONTROLLER_PATH + "/getlist").then((response) => response.data);
    }
    getlistaccicarefacilities(selectedProviderId) {
        return axios.get(CONTROLLER_PATH + "/GetListAccicareFacilities", selectedProviderId > 0 ? { params: { selectedProviderId: selectedProviderId } } : {}).then((response) => response.data);
    }
    getUserProvidersList() {
        return axios.get(CONTROLLER_PATH + "/getUserProvidersList").then((response) => response.data);
    }

    getPatientAuthorizers(providerId) {
        return axios.get(CONTROLLER_PATH + "/GetPatientAuthorizers/" + providerId).then((response) => response.data);
    }
    getIncidentAuthorizers(providerId) {
        return axios.get(CONTROLLER_PATH + "/GetIncidentAuthorizers/" + providerId).then((response) => response.data);
    }

    getDisciplines(providerId) {
        return axios.get(CONTROLLER_PATH + "/GetDisciplines" + (typeof providerId === "undefined" ? "" : "/" + providerId)).then((response) => response.data);
    }
    getMedediDisciplines(providerId) {
        return axios.get(CONTROLLER_PATH + "/GetMedediDisciplines" + (typeof providerId === "undefined" ? "" : "/" + providerId)).then((response) => response.data);
    }

    //UPDATE
    update(id, formData) {
        return axios
            .put(CONTROLLER_PATH + '/' + id, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => response.data);
    }

    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + "/" + id).then(() => {});
    }

    //PROVIDER FILES
    //CREATE
    createFile(providerId, formdata) {
        return axios
            .post(CONTROLLER_PATH + "/" + providerId + "/file", formdata, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }
    //READ
    getFileTypes() {
        return axios.get(CONTROLLER_PATH + "/getFileTypes").then((response) => response.data);
    }
    //UPDATE
    updateFile(entity) {
        return axios.put(CONTROLLER_PATH + "/" + entity.providerId + "/file/" + entity.id, entity).then((response) => response.data);
    }
    //DELETE
    deleteFile(providerId, providerFileId) {
        return axios.delete(CONTROLLER_PATH + "/" + providerId + "/file/" + providerFileId).then((response) => response.data);
    }
}

export default new ProviderService();
